import React from 'react';

import { notification, Button } from 'antd';
import { Popconfirm } from 'antd';
import clsx from 'clsx';
import { TooltipPlacement } from 'antd/lib/tooltip';
import styles from './RemoveAllSchedule.module.less';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useScheduleRemovingState } from '../RemoveScheduleButton/hooks';

export type RemoveAllScheduleProps = {
  scheduleItems: any;
  className?: string;
  tooltipPlacement?: TooltipPlacement;
};


const RemoveAllSchedule: React.FC<RemoveAllScheduleProps> = ({
  scheduleItems,
  className,
  tooltipPlacement,

}: RemoveAllScheduleProps) => {
  const [{ loading, error }, { removeSchedule }] = useScheduleRemovingState();
 
  let sheduleIdssss1: any = scheduleItems && scheduleItems?.map((types: any) => (types.id));
  let ScheduledAll1 = sheduleIdssss1 && sheduleIdssss1.join(',');

  const disabled = loading || (ScheduledAll1);

  const handleDeleteConfirm = () => {
    if (ScheduledAll1 && removeSchedule) {
      removeSchedule({id: "", description: ""}, ScheduledAll1);
    }
  };

  React.useEffect(() => {
    if (error) {
      notification.error({ message: error.message || error });
    }
  }, [error, ScheduledAll1]);

  return (
    <>
      <Popconfirm
        title="Are you sure you want to remove all schedules?"
        okText="Yes, I am sure"
        cancelText="No, keep it for now"
        placement={tooltipPlacement || 'bottom'}
        icon={null}
        onConfirm={handleDeleteConfirm}
      >
        <Button
          type="link"
          style={
            disabled
              ? { marginLeft: 8, maxWidth: '140px', marginTop: '-10px', fontSize: '13px' }
              : { maxWidth: '140px', marginTop: '-10px', fontSize: '13px' }
          }
        >
          <FontAwesomeIcon icon={['fal', 'minus-circle']} color={'gray'} style={{ marginRight: '10px' }}
            className={clsx(styles.icon, { [styles.disabled]: disabled }, className)}
          /> Remove All
        </Button>
      </Popconfirm>


    </>
  );
};

export default RemoveAllSchedule;

